import React, {useState} from 'react'
import { Button, Col, Row } from 'react-bootstrap';
import HttpRequest from '../../services/HttpRequest';
import Notify from '../../services/Notify'

import LoadingV2 from '../../component/Loading/LoadingV2';
import BizLocationSelector from '../../component/BizLocation/BizLocationSelector';
import { DateRangeSelector } from '../../component/Date/DateRangeSelector';
import InventoryStatusSelector, { INVENTORY_STATUS } from '../../Inventory/components/InventoryStatusSelector';
import ApplicationUserSelector from '../../user/application/component/ApplicationUserSelector';
import { dayMonthYearAtTimeWithSeconds, getDaysAgo, todayLastTime } from "../../utils/dates";
import BreadcrumbItem from '../../component/BreadcrumbItem/BreadcrumbItem';
import InventoryService from '../../services/InventoryService';


class InventoryGrid {



  actionsButtons = async (inventoryId, reloadGrid) => {
      try {
        await new InventoryService().finishInventory(inventoryId, {})
        Notify.success('Inventário finalizado com sucesso!')
      } catch (error) {
        Notify.error('Erro ao Finalizar o inventário', error)
      } finally {
        reloadGrid && reloadGrid()
      }
    }

  title = 'Lista de inventários'

  customBreadcrumbs = [
    <BreadcrumbItem key={1} title="Lista de inventários" />,
  ]

  customFilters = {
    startDate: getDaysAgo(7),
    endDate: todayLastTime()
  }

  exportNewPage = true;

  showPdfButton = false;

  httpRequest = new HttpRequest();


  columns = [
    {
      Header: 'Data/Hora',
      accessor: 'createdAt',
      Cell: ({ original }) => original.createdAt && dayMonthYearAtTimeWithSeconds(original.createdAt)
    },
    {
      Header: 'Local',
      accessor: 'bizLocation.friendlyName',
      HeaderColumn: true,
      Cell: ({ original }) => original.bizLocation && original.bizLocation.friendlyName
    },
    {
      Header: 'Criado por',
      accessor: 'userCreatedBy.name',
      Cell: ({original}) => original.userCreatedBy && original.userCreatedBy.name || 'Usuário não identificado'
    },
    {
      Header: 'Finalizado por',
      accessor: 'userFinished.name',
      Cell: ({original}) => original.userFinished && original.userFinished.name || 'Usuário não identificado'
    },
    {
      Header: 'Status',
      accessor: 'status',
      Cell: ({ original }) => original.status && INVENTORY_STATUS[original.status] || 'Status Desconhecido'
    },
    {
      Header: 'Opções',
      sortable: false,
      filterable: false,
      export: false,
      Cell: ({ original }) => {
        return (
          <Row className="justify-content-center m-auto align-items-center">
            <Col>
              <Button href={`#/inventories/${original.id}`} bsSize="large" bsStyle='primary'>Detalhes</Button>
            </Col>
             {
              INVENTORY_STATUS[original.status] === INVENTORY_STATUS.EXECUTING &&
              <Col>
                  <Button onClick={() => this.actionsButtons(original.id, this.forceReload)}  bsSize="large"  bsStyle='info'>Finalizar</Button>
              </Col>
            }
          </Row>
        )
      }
    }
  ];

  customFilterComponent = (_props, _state, onChange) => {
    const handleBizLocationSelect = (bizLocationId) => {
      this.customFilters.bizLocationId = bizLocationId
      onChange(this.customFilters)
    }

    const handleProductTypeSelect = (userId) => {
      this.customFilters.userId = userId
      onChange(this.customFilters)
    }

    const handleInventoryStatusSelect = (status) => {
      this.customFilters.status = status && status.value
      onChange(this.customFilters)
    }

    const handleDateRangeSelect = (startDate, endDate) => {
      this.customFilters.startDate = startDate
      this.customFilters.endDate = endDate
      onChange(this.customFilters)
    }
    return (
      <Row>
        <Col md={3}>
          <BizLocationSelector setValue={handleBizLocationSelect}/>
        </Col>
        <Col md={3}>
          <ApplicationUserSelector setValue={handleProductTypeSelect}/>
        </Col>
        <Col md={3}>
          <InventoryStatusSelector onChange={handleInventoryStatusSelect} />
        </Col>
        <Col md={3}>
          <DateRangeSelector defaultStartDate={this.customFilters.startDate} onChange={handleDateRangeSelect}/>
        </Col>
      </Row>
    )
  }

  endpoint = () => {
    const params = new URLSearchParams({})
    const { customFilters } = this

    if (customFilters) {
      customFilters.status && params.append('status', customFilters.status)
      customFilters.bizLocationId && params.append('bizLocationId', customFilters.bizLocationId)
      customFilters.userId && params.append('userExecutedId', customFilters.userId)
      customFilters.startDate && params.append('startDate', customFilters.startDate.toISOString())
      customFilters.endDate && params.append('endDate', customFilters.endDate.toISOString())
    }

    return `inventory/v1/inventories?${params.toString()}`
  }
}

export default InventoryGrid;



// WEBPACK FOOTER //
// ./src/customGrid/entities/InventoryGrid.js